import { useContext, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { EditabilityContext } from '../../context';
import { TAppState } from '../../redux';

import { TkPanelContainer } from './TkPanelContainer';

/**
 * Ворота: пока панель закрыта, она не смонтирована вовсе.
 *
 * Это не косметика. Обход поддерева стоит сотни миллисекунд на книге, и
 * считать его при закрытой панели значит платить за то, на что никто не
 * смотрит. Поэтому же у пункта меню нет счётчика.
 */
export function TkPanel() {
  const { getNodeByRef } = useContext(EditabilityContext);
  const { selected } = useSelector((state: TAppState) => state.editor);
  const { isTkPanelOpen } = useSelector((state: TAppState) => state.general);

  const currentNode = useMemo(
    () => (selected ? getNodeByRef(selected) : selected),
    [getNodeByRef, selected],
  );

  if (!currentNode || !isTkPanelOpen) {
    return null;
  }

  return <TkPanelContainer entity={currentNode} />;
}
